import {
    ATTEMPT_FETCH_ACCOUNT,
    ATTEMPT_SIGN_OUT,
    ATTEMPT_FETCH_ACCOUNT_ORGANIZATIONS,
    SWITCH_ORGANIZATION,
    ATTEMPT_CREATE_ORGANIZATION,
} from 'shared_redux/actions';

export const fetchAccount = () => ({ type: ATTEMPT_FETCH_ACCOUNT });

export const signOut = (inviteCode) => ({ type: ATTEMPT_SIGN_OUT, inviteCode });

export const fetchAccountOrganizations = () => ({ type: ATTEMPT_FETCH_ACCOUNT_ORGANIZATIONS });

export const switchOrganization = (organizationId) => ({
    type: SWITCH_ORGANIZATION,
    payload: { organizationId }
});

export const createOrganization = (name, timezone) => ({
    type: ATTEMPT_CREATE_ORGANIZATION,
    payload: { name, timezone }
});
